import React from "react";
import styles from "../../styles/components/common/Loader.module.css";


const Loader = ({ inline = false }) => {
  if (inline) {
    return (
      <div className={styles.loaderInline}>
        <div className={styles.loader} />
      </div>
    );
  }
  return (
    <div className={ styles.loaderOverlay }>
      <div className={ styles.loader } />
    </div>
  );
};

export default Loader;
